import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import subscriptionHero from "@/assets/subscription-hero.jpg";

const benefits = [
  "Save 15% on every order",
  "Free shipping on all subscriptions",
  "Flexible delivery schedule",
  "Easy to pause, skip or cancel anytime",
  "Early access to limited editions",
  "Exclusive subscriber-only content"
];

const SubscriptionSection = () => {
  return (
    <section className="py-20 relative">
      {/* Cosmic background effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-solr-space-darker to-solr-space-dark/50 opacity-80"></div>
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-solr-nebula-purple/5 rounded-full filter blur-[100px]"></div>
      <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-solr-electric-blue/5 rounded-full filter blur-[100px]"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="cosmic-card overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-2 h-full">
              {/* Image side */}
              <div className="relative h-64 md:h-auto">
                <div className="absolute inset-0 bg-gradient-to-r from-solr-nebula-purple/20 to-solr-electric-blue/20"></div>
                <img 
                  src={subscriptionHero} 
                  alt="SOLR Subscription - Neural Enhancement Beverages" 
                  className="h-full w-full object-cover" 
                />
                
                {/* Neural overlay */}
                <div className="absolute inset-0 opacity-30">
                  {[...Array(5)].map((_, i) => (
                    <div 
                      key={i}
                      className="absolute neural-connection"
                      style={{
                        top: `${Math.random() * 100}%`,
                        left: 0,
                        animationDelay: `${i * 0.3}s`
                      }}
                    ></div>
                  ))}
                </div>
                
                {/* Tag */}
                <div className="absolute top-4 left-4 bg-solr-nebula-purple/90 text-white text-xs font-bold px-4 py-1 rounded-full">
                  SAVE 15%
                </div>
              </div>
              
              {/* Content side */}
              <div className="p-8 md:p-10 flex flex-col">
                <div className="mb-6">
                  <h2 className="text-2xl md:text-3xl font-bold mb-2">
                    Subscribe & <span className="neural-text">Save</span>
                  </h2>
                  <p className="text-solr-starfield-silver">
                    Join our neural enhancement journey with regular deliveries 
                    of your favorite SOLR beverages.
                  </p>
                </div>
                
                <div className="space-y-3 mb-8">
                  {benefits.map((benefit, index) => (
                    <div key={index} className="flex items-start">
                      <CheckCircle2 className="w-5 h-5 text-solr-nebula-purple mr-3 flex-shrink-0" />
                      <span className="text-sm text-solr-starfield-silver">{benefit}</span>
                    </div>
                  ))}
                </div>
                
                <div className="mt-auto space-y-4">
                  <Button className="btn-primary w-full">Subscribe Now</Button>
                  <p className="text-xs text-center text-solr-starfield-silver">
                    No commitment. Cancel or modify your subscription anytime.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubscriptionSection;
